import React from 'react'
import PageHeader from '../components/common/PageHeader';
import { getCookie } from '../services/DataRequestService';

function MyProfile() {
  return (
    <div style={{ width: '100%', boxSizing: 'border-box', background: '#f4f3ef' }}>
      <PageHeader
        title="My Profile"
        subtitle="Account details for the signed-in user."
      />
      <div className="mycontainer flex justify-center profile-container">
        <table className="table reviewtable table-bordered table-hover" style={{ width: "100%", fontFamily: 'Poppins, sans-serif' }}>
          <tbody>
            <tr>
              <td>Name</td>
              <td>{getCookie('username')?.toUpperCase()}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>{getCookie('email')?.toUpperCase()}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default MyProfile;
